import React, { useEffect, useState, } from 'react';
import PropTypes from 'prop-types';
import restoreSession, { sessionNeedsRestore, } from '../modules/SessionBootstrap';
import './SessionGate.css';

/**
 * Holds the app back until a stored session has been redeemed or discarded, so the
 * router never has to decide where to send the user while that answer is in flight.
 * Without the gate a recoverable session flashes the login form before bouncing to
 * the dashboard.
 */
const SessionGate = ({ children, }) => {
  // Only the expired-token path talks to the network; everything else is ready now.
  const [ ready, setReady, ] = useState(() => !sessionNeedsRestore());

  useEffect(() => {
    let cancelled = false;

    restoreSession().finally(() => {
      if (!cancelled) {
        setReady(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) {
    return (
      <div className="session-gate">
        <div className="session-gate-message">Restoring your session…</div>
      </div>
    );
  }

  return <>{children}</>;
};

SessionGate.propTypes = {
  children: PropTypes.node,
};

export default SessionGate;